import { Product } from '@mews-distributor/data-access';
import { AllProductsQuery } from '../graphql/generatedClient';

/**
 * Converts GraphQL PricedProduct array to REST Product array format for Redux store.
 * This ensures backward compatibility with the existing Redux structure and selectors.
 * Note: enterpriseId is added to products in the reducer, not here.
 */
export const convertPricedProductsToProducts = (pricedProducts: AllProductsQuery['allProducts']): Product[] => {
    return pricedProducts.map((pricedProduct) => {
        // Convert name from KeyValuePairOfStringAndString[] to { [key: string]: string }
        const name: { [key: string]: string } = {};
        if (pricedProduct.name != null) {
            for (const pair of pricedProduct.name) {
                name[pair.key] = pair.value;
            }
        }

        // Convert description from KeyValuePairOfStringAndString[] to { [key: string]: string }
        const description: { [key: string]: string } = {};
        if (pricedProduct.description != null) {
            for (const pair of pricedProduct.description) {
                description[pair.key] = pair.value;
            }
        }

        // Convert prices from KeyValuePairOfStringAndDecimal[] to Record<string, number>
        const prices: Record<string, number> = {};
        if (pricedProduct.prices != null) {
            for (const pair of pricedProduct.prices) {
                prices[pair.key] = pair.value;
            }
        }

        // Convert amounts from KeyValuePairOfStringAndAmount_DoNotUse[] to Record<string, unknown>
        const amounts: Record<string, unknown> = {};
        if (pricedProduct.amounts != null) {
            for (const pair of pricedProduct.amounts) {
                amounts[pair.key] = pair.value;
            }
        }

        // Build the Product object matching the REST API format
        const product: Product = {
            id: pricedProduct.id,
            serviceId: pricedProduct.serviceId,
            name,
            description,
            includedByDefault: pricedProduct.includedByDefault,
            alwaysIncluded: pricedProduct.alwaysIncluded,
            prices,
            pricing:
                pricedProduct.pricing != null
                    ? (pricedProduct.pricing as Product['pricing'])
                    : ({} as Product['pricing']),
            amounts,
            charging: pricedProduct.charging ?? null,
            chargingMode: pricedProduct.chargingMode ?? '',
            posting: pricedProduct.posting ?? null,
            postingMode: pricedProduct.postingMode ?? '',
            ordering: pricedProduct.ordering,
            categoryId: pricedProduct.categoryId ?? null,
            imageId: pricedProduct.imageId ?? null,
            relativePrice: pricedProduct.relativePrice ?? null,
            classifications: pricedProduct.classifications ?? [],
        };

        return product;
    });
};
